import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, FolderKanban, LifeBuoy, LogOut, Search, FileText } from "lucide-react";
import { usePortalAuth } from "@/contexts/PortalAuthContext";
import Avatar from "@/components/Avatar";

const NAV = [
  { to: "/portal/", label: "Genel", icon: Home, end: true },
  { to: "/portal/dosyalar", label: "Dosyalar & Raporlar", icon: FolderKanban },
  { to: "/portal/raporlar", label: "Raporlar (PDF)", icon: FileText },
  { to: "/portal/anahtar-kelimeler", label: "Anahtar Kelimeler", icon: Search },
  { to: "/portal/destek", label: "Destek", icon: LifeBuoy },
];

export default function PortalLayout({ children }) {
  const { customer, logout } = usePortalAuth();
  return (
    <div className="min-h-screen flex bg-[#FAFAFB]">
      <aside className="hidden lg:flex w-60 bg-white border-r border-[#ECECEF] flex-col">
        <div className="px-5 py-5 border-b border-[#ECECEF]">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#0F172A] flex items-center justify-center text-white font-bold text-xs">KY</div>
            <div><div className="text-[13px] font-semibold leading-none">Müşteri Portalı</div><div className="text-[10px] text-[#94A3B8] mt-0.5">Kamil Yıldırım</div></div>
          </div>
        </div>
        <nav className="flex-1 py-3 px-2">
          {NAV.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({isActive}) => `flex items-center gap-2 px-3 py-2 rounded-md text-[13px] mb-0.5 ${isActive ? "bg-[#F4F4F5] text-[#0F172A] font-medium" : "text-[#64748B] hover:bg-[#F4F4F5]"}`}>
              <item.icon size={15}/><span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#ECECEF]">
          <div className="flex items-center gap-2 px-2 mb-2"><Avatar name={customer?.name} size={30}/><div className="min-w-0"><div className="text-[12px] font-medium truncate">{customer?.name}</div><div className="text-[10px] text-[#94A3B8] truncate">{customer?.company}</div></div></div>
          <button onClick={logout} className="ky-btn ky-btn-outline ky-btn-sm w-full" data-testid="portal-logout"><LogOut size={12}/>Çıkış</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-14 bg-white border-b border-[#ECECEF] flex items-center px-6 sticky top-0 z-20">
          <div className="text-sm text-[#64748B]">Hoş geldiniz, <span className="font-medium text-[#0F172A]">{customer?.name}</span></div>
        </header>
        <main className="flex-1 overflow-y-auto"><div className="max-w-[1200px] mx-auto p-6">{children}</div></main>
      </div>
    </div>
  );
}
